import React from 'react';
import AccountStatusSuccess from 'components/shared/AccountStatusSuccess';

const WebAccountVerified: React.FC = () => (
  <AccountStatusSuccess bodyTranslationKey="MPL_CREATE_ACCOUNT_VERIFY_DESC" dataTestId="web-account-verified" />
);

export default WebAccountVerified;
